// extracted by mini-css-extract-plugin
module.exports = {"container":"Terms_container__PH0se","box":"Terms_box__1we5_"};